export const PROCEDURES_MODAL_TEXTS = {
  HOSPITAL_INFO: 'Hospital info',
  HOSPITAL_NAME: 'Name',
  HOSPITAL_ID: 'Hospital ID',
  COUNTRY: 'Country',
  TOTAL_CONDUCTED: 'Total conducted',
};
